import { baseApi as $fetch } from './BaseApi';

export const EVENT_TYPES = {
  library: 'use_library',
  publicBlogPage: 'public_blog_page',
  publicProductPage: 'public_product_page',
  publicTemplatePage: 'public_template_page',
  publicCollectionPage: 'public_collection_page',
  publicHomePage: 'public_home_page',
  saveToLibrary: 'save_to_library',
};

export const TemplatePagePublicEvent: Record<string, string> = {
  'template-index': EVENT_TYPES.publicHomePage,
  'template-page': EVENT_TYPES.publicTemplatePage,
  'template-product': EVENT_TYPES.publicProductPage,
  'template-collection': EVENT_TYPES.publicCollectionPage,
  'template-article': EVENT_TYPES.publicBlogPage,
};

const submitPath = '/api/event/submit';
const countPath = '/api/event/countBy';

interface EventRequest {
  event_type?: string;
  event_types?: string;
  g_id?: string;
  shopify_domain?: string;
  limit?: number;
}

interface EventResponse {
  status: string;
  message: string;
}

const eventService = () => {
  const submitEvent = (params: EventRequest): EventResponse => {
    return $fetch.post(submitPath, {
      ...params,
    });
  };

  const countBy = (params: EventRequest) => {
    return $fetch.get(countPath, {
      params,
    });
  };

  return {
    submitEvent,
    countBy,
  };
};

export { eventService as default };
